export default {
      path: '/lvy-third-party-share-info',
      component: () => import('./LVYThirdPartyShareInfo'),
      meta: {
        title: '《青藤之恋》第三方信息共享清单',
        designWidth: 750,
        expireIn: 'Thu Dec 31 2099 08:00:00 GMT+0800 (China Standard Time)',
        axiosConfig: {
          baseURL: '',
          withCredentials: false,
          postContentType: 'FormData'
        }
      }
    }
